module.exports = __webpack_public_path__ + "img/first-day-1.311fc772.webp";